import * as z from "zod";

export const deleteLocation = {
  name: "deleteLocation" as const,
  input: z.object({ locationId: z.string() }),
  output: z.null(),
};
